import React, { useEffect } from 'react';
import { useArticles } from './hooks/useArticles';
import LoadMoreButton from '../btnLoadMore';
import { useTranslation } from 'react-i18next';

const Articles = () => {
  const { t } = useTranslation();
  const articlesPerPage = 6;
  const { articles, getPageNumber, currentPageLoaded, loading, hasMoreArticles } = useArticles(articlesPerPage);

  useEffect(() => {
    const initialPage = getInitialPageToLoad();
    getPageNumber(initialPage);
  }, []);

  useEffect(() => {
    if (loading || currentPageLoaded <= 1) {
      return;
    }

    const allArticles = document.querySelectorAll("#articlesWrapper .articles .article");
    // Get the first article of the current "page"
    let scrollTargetElement = allArticles[currentPageLoaded * articlesPerPage - articlesPerPage];

    // If no first article was found, abort and don't scroll
    if (!scrollTargetElement) {
      return;
    }

    const scrollTarget = scrollTargetElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: scrollTarget,
      behavior: "smooth"
    });
  }, [articles])

  const getInitialPageToLoad = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');

    if (!pageParam || pageParam === "0") return 1;
    return parseInt(pageParam);
  }

  const loadNextPage = () => {
    const nextPageNumber = currentPageLoaded + 1;
    getPageNumber(nextPageNumber);
    updateQueryVar(nextPageNumber);
  }

  const updateQueryVar = (nextPageNumber: number) => {
    var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?page=' + nextPageNumber;
    window.history.pushState({ path: newURL }, '', newURL);
  }

  const getShortDescription = (string: string | null) => {
    const maxLength = 170;

    if (string === null) {
      return '';
    }

    if (string.length < maxLength) {
      return string;
    }

    return string.substring(0, 170) + ' ...';
  }

  return (
    <>
      <ul className="articles">
        {articles && articles.map((item) => {
          return (
            <li className="article" key={item.id}>
              <a className="article-link" href={item.url}>
                <div className="image-wrapper">
                  <img src={item.imageUrl} />
                </div>
                <h3 className="title">{item.title}</h3>
                <p className="description">
                  {getShortDescription(item.description)}
                </p>
              </a>
            </li>
          )
        })}
      </ul>

      { hasMoreArticles && (
        <div style={{ textAlign: "center" }}>
          <LoadMoreButton onClick={loadNextPage} text={loading ? t('articles.loading') : t('articles.loadMore')} />
        </div>
      )}
    </>
  )
}

export default Articles;
